module.exports = __webpack_public_path__ + "static/media/024.6abcd612.jpg";